import {useEffect, useState} from "react";
import {useForm, Controller, useWatch} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row } from "antd";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	GroupRadioField,
	SelectUserAll,
	SelectField
} from "~/components/Forms";
import {
	getWardOptionByProvinceId,
	provinceChange
} from "../../../../utils";
import {
	useProvince
} from "../../../../hooks";

function CustomerFormAddEdit({item, onHandleSubmit}) {

	const isEdit = Boolean(item?.id);

	let provinceOptions = useProvince();

	let [wardOptions, setWardOptions] = useState([{
		value: 0,
		label: "Chọn phường xã"
	}]);

	const [forValue, setForValue] = useState((isEdit) ? item.for : 'canhan');

	const forOptions = [
		{value: 'canhan', label: 'Cá Nhân'},
		{value: 'congty', label: 'Công Ty'},
	];

	const initialValues = {
		for: item?.for ?? 'canhan',
		companyName: item?.companyName ?? '',
		taxCode: item?.taxCode ?? '',
		name: item?.name ?? '',
		numberId: item?.numberId ?? '',
		email: item?.email ?? '',
		phone: item?.phone ?? '',
		address: item?.address ?? '',
		userShareId: item?.userShareId ?? '',
		province: parseInt(item?.province ?? 0),
		ward: parseInt(item?.ward ?? 0),
	}

	const validationSchema = Yup.object().shape({
		for: Yup.string().nullable().required('Bạn chưa chọn loại khách hàng'),
		companyName: Yup.string().nullable().when('for', {
			is: 'congty',
			then: Yup.string().required('Tên công ty không được bỏ trống'),
		}),
		taxCode: Yup.string().nullable().when('for', {
			is: 'congty',
			then: Yup.string().required('Mã số thuế không được bỏ trống'),
		}),
		name: Yup.string().required('Họ tên khách hàng không được để trống'),
		email: Yup.string().email('Email không đúng định dạng').required('Email không được để trống'),
		phone: Yup.string().required('Số điện thoại không được để trống'),
		province: Yup.string().required('Tỉnh thành không được để trống'),
		ward: Yup.string().required('Phường xã không được để trống'),
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset, setValue} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	//Thay đổi loại khách hàng
	const forInput = useWatch({control, name: "for"});

	if (forInput !== forValue) setForValue(forInput);

	//Thay đổi tỉnh thành
	const handleProvinceChange = async (value) =>
	{
		await provinceChange({
			value,
			setWardOptions: setWardOptions,
			setValue: function ()
			{
				setValue('ward', 0);
			}
		})
	}

	useEffect(() => {
		if (item?.id) {
			async function loadLocation(item) {
				if (item?.province !== 0)
				{
					// eslint-disable-next-line react-hooks/exhaustive-deps
					wardOptions = await getWardOptionByProvinceId(item.province)
					setWardOptions(wardOptions);
				}
			}

			loadLocation(item);
		}
		reset(initialValues);

	}, [item, item?.province]);

	const renderCompanyInfo = (forValue) => {
		if ((forValue === 'congty')) return (
			<>
				<p className="heading">Thông tin khách hàng</p>
				<Row gutter={10}>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="companyName" render={({field}) => (
							<InputField label="Tên công ty" errors={errors} {...field}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="taxCode" render={({field}) => (
							<InputField label="Mã số thuế" errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
			</>
		)
	}

	const onSubmit = async (data) => {
		await onHandleSubmit(data, isEdit);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Loại khách hàng</p>
			<Controller control={control} name="for" render={({field}) => (
				<GroupRadioField options={forOptions} errors={errors} {...field}/>
			)}/>
			{renderCompanyInfo(forValue)}
			<p className="heading">Thông tin khách hàng</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="name" render={({field}) => (
						<InputField label="Họ tên khách hàng (Người đại diện)" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="numberId" render={({field}) => (
						<InputField label="CCCD / CMND" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="email" render={({field}) => (
						<InputField type="email" label="Email liên hệ" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="phone" render={({field}) => (
						<InputField type="tel" label="Số điện thoại" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row gutter={10}>
				<Col className="gutter-row" span={24}>
					<Controller control={control} name="address" render={({field}) => (
						<InputField label="Địa chỉ" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="province" render={({field}) => (
						<SelectField placeholder="Chọn tỉnh thành" options={provinceOptions} errors={errors} {...field}
									 onChange={(value, event) => {
										 handleProvinceChange(value);
										 field.onChange(value, event);
									 }}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="ward" render={({field}) => (
						<SelectField placeholder="Chọn phường xã" options={wardOptions} errors={errors} {...field}/>
					)}/>
				</Col>
				{
					(isEdit && item?.ward === 0 && item?.wardOld !== 0) && <Col className="gutter-row mb-1" span={24}>{item?.addressFull}</Col>
				}
			</Row>
			<p className="heading">Kinh doanh</p>
			<Controller control={control} name="userShareId" render={({field}) => (
				<SelectUserAll label="Share với nhân viên" options={[]} errors={errors} {...field} />
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm khách hàng'}</Button>
			</div>
		</form>
	)
}

export default CustomerFormAddEdit;